import { __assign, __extends } from "tslib";
import { SNSServiceException as __BaseException } from "./SNSServiceException";
var AuthorizationErrorException = (function (_super) {
    __extends(AuthorizationErrorException, _super);
    function AuthorizationErrorException(opts) {
        var _this = _super.call(this, __assign({ name: "AuthorizationErrorException", $fault: "client" }, opts)) || this;
        _this.name = "AuthorizationErrorException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, AuthorizationErrorException.prototype);
        return _this;
    }
    return AuthorizationErrorException;
}(__BaseException));
export { AuthorizationErrorException };
var InternalErrorException = (function (_super) {
    __extends(InternalErrorException, _super);
    function InternalErrorException(opts) {
        var _this = _super.call(this, __assign({ name: "InternalErrorException", $fault: "server" }, opts)) || this;
        _this.name = "InternalErrorException";
        _this.$fault = "server";
        Object.setPrototypeOf(_this, InternalErrorException.prototype);
        return _this;
    }
    return InternalErrorException;
}(__BaseException));
export { InternalErrorException };
var InvalidParameterException = (function (_super) {
    __extends(InvalidParameterException, _super);
    function InvalidParameterException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidParameterException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidParameterException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidParameterException.prototype);
        return _this;
    }
    return InvalidParameterException;
}(__BaseException));
export { InvalidParameterException };
var NotFoundException = (function (_super) {
    __extends(NotFoundException, _super);
    function NotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "NotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "NotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, NotFoundException.prototype);
        return _this;
    }
    return NotFoundException;
}(__BaseException));
export { NotFoundException };
var ThrottledException = (function (_super) {
    __extends(ThrottledException, _super);
    function ThrottledException(opts) {
        var _this = _super.call(this, __assign({ name: "ThrottledException", $fault: "client" }, opts)) || this;
        _this.name = "ThrottledException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ThrottledException.prototype);
        return _this;
    }
    return ThrottledException;
}(__BaseException));
export { ThrottledException };
var FilterPolicyLimitExceededException = (function (_super) {
    __extends(FilterPolicyLimitExceededException, _super);
    function FilterPolicyLimitExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "FilterPolicyLimitExceededException", $fault: "client" }, opts)) || this;
        _this.name = "FilterPolicyLimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, FilterPolicyLimitExceededException.prototype);
        return _this;
    }
    return FilterPolicyLimitExceededException;
}(__BaseException));
export { FilterPolicyLimitExceededException };
var SubscriptionLimitExceededException = (function (_super) {
    __extends(SubscriptionLimitExceededException, _super);
    function SubscriptionLimitExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "SubscriptionLimitExceededException", $fault: "client" }, opts)) || this;
        _this.name = "SubscriptionLimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, SubscriptionLimitExceededException.prototype);
        return _this;
    }
    return SubscriptionLimitExceededException;
}(__BaseException));
export { SubscriptionLimitExceededException };
export var LanguageCodeString;
(function (LanguageCodeString) {
    LanguageCodeString["de_DE"] = "de-DE";
    LanguageCodeString["en_GB"] = "en-GB";
    LanguageCodeString["en_US"] = "en-US";
    LanguageCodeString["es_419"] = "es-419";
    LanguageCodeString["es_ES"] = "es-ES";
    LanguageCodeString["fr_CA"] = "fr-CA";
    LanguageCodeString["fr_FR"] = "fr-FR";
    LanguageCodeString["it_IT"] = "it-IT";
    LanguageCodeString["jp_JP"] = "ja-JP";
    LanguageCodeString["kr_KR"] = "kr-KR";
    LanguageCodeString["pt_BR"] = "pt-BR";
    LanguageCodeString["zh_CN"] = "zh-CN";
    LanguageCodeString["zh_TW"] = "zh-TW";
})(LanguageCodeString || (LanguageCodeString = {}));
var OptedOutException = (function (_super) {
    __extends(OptedOutException, _super);
    function OptedOutException(opts) {
        var _this = _super.call(this, __assign({ name: "OptedOutException", $fault: "client" }, opts)) || this;
        _this.name = "OptedOutException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, OptedOutException.prototype);
        return _this;
    }
    return OptedOutException;
}(__BaseException));
export { OptedOutException };
var UserErrorException = (function (_super) {
    __extends(UserErrorException, _super);
    function UserErrorException(opts) {
        var _this = _super.call(this, __assign({ name: "UserErrorException", $fault: "client" }, opts)) || this;
        _this.name = "UserErrorException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, UserErrorException.prototype);
        return _this;
    }
    return UserErrorException;
}(__BaseException));
export { UserErrorException };
var ConcurrentAccessException = (function (_super) {
    __extends(ConcurrentAccessException, _super);
    function ConcurrentAccessException(opts) {
        var _this = _super.call(this, __assign({ name: "ConcurrentAccessException", $fault: "client" }, opts)) || this;
        _this.name = "ConcurrentAccessException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConcurrentAccessException.prototype);
        return _this;
    }
    return ConcurrentAccessException;
}(__BaseException));
export { ConcurrentAccessException };
var InvalidSecurityException = (function (_super) {
    __extends(InvalidSecurityException, _super);
    function InvalidSecurityException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidSecurityException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidSecurityException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidSecurityException.prototype);
        return _this;
    }
    return InvalidSecurityException;
}(__BaseException));
export { InvalidSecurityException };
var StaleTagException = (function (_super) {
    __extends(StaleTagException, _super);
    function StaleTagException(opts) {
        var _this = _super.call(this, __assign({ name: "StaleTagException", $fault: "client" }, opts)) || this;
        _this.name = "StaleTagException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, StaleTagException.prototype);
        return _this;
    }
    return StaleTagException;
}(__BaseException));
export { StaleTagException };
var TagLimitExceededException = (function (_super) {
    __extends(TagLimitExceededException, _super);
    function TagLimitExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "TagLimitExceededException", $fault: "client" }, opts)) || this;
        _this.name = "TagLimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TagLimitExceededException.prototype);
        return _this;
    }
    return TagLimitExceededException;
}(__BaseException));
export { TagLimitExceededException };
var TagPolicyException = (function (_super) {
    __extends(TagPolicyException, _super);
    function TagPolicyException(opts) {
        var _this = _super.call(this, __assign({ name: "TagPolicyException", $fault: "client" }, opts)) || this;
        _this.name = "TagPolicyException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TagPolicyException.prototype);
        return _this;
    }
    return TagPolicyException;
}(__BaseException));
export { TagPolicyException };
var TopicLimitExceededException = (function (_super) {
    __extends(TopicLimitExceededException, _super);
    function TopicLimitExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "TopicLimitExceededException", $fault: "client" }, opts)) || this;
        _this.name = "TopicLimitExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TopicLimitExceededException.prototype);
        return _this;
    }
    return TopicLimitExceededException;
}(__BaseException));
export { TopicLimitExceededException };
var ResourceNotFoundException = (function (_super) {
    __extends(ResourceNotFoundException, _super);
    function ResourceNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "ResourceNotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "ResourceNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ResourceNotFoundException.prototype);
        return _this;
    }
    return ResourceNotFoundException;
}(__BaseException));
export { ResourceNotFoundException };
export var NumberCapability;
(function (NumberCapability) {
    NumberCapability["MMS"] = "MMS";
    NumberCapability["SMS"] = "SMS";
    NumberCapability["VOICE"] = "VOICE";
})(NumberCapability || (NumberCapability = {}));
export var RouteType;
(function (RouteType) {
    RouteType["Premium"] = "Premium";
    RouteType["Promotional"] = "Promotional";
    RouteType["Transactional"] = "Transactional";
})(RouteType || (RouteType = {}));
var ValidationException = (function (_super) {
    __extends(ValidationException, _super);
    function ValidationException(opts) {
        var _this = _super.call(this, __assign({ name: "ValidationException", $fault: "client" }, opts)) || this;
        _this.name = "ValidationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ValidationException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ValidationException;
}(__BaseException));
export { ValidationException };
export var SMSSandboxPhoneNumberVerificationStatus;
(function (SMSSandboxPhoneNumberVerificationStatus) {
    SMSSandboxPhoneNumberVerificationStatus["Pending"] = "Pending";
    SMSSandboxPhoneNumberVerificationStatus["Verified"] = "Verified";
})(SMSSandboxPhoneNumberVerificationStatus || (SMSSandboxPhoneNumberVerificationStatus = {}));
var EndpointDisabledException = (function (_super) {
    __extends(EndpointDisabledException, _super);
    function EndpointDisabledException(opts) {
        var _this = _super.call(this, __assign({ name: "EndpointDisabledException", $fault: "client" }, opts)) || this;
        _this.name = "EndpointDisabledException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EndpointDisabledException.prototype);
        return _this;
    }
    return EndpointDisabledException;
}(__BaseException));
export { EndpointDisabledException };
var InvalidParameterValueException = (function (_super) {
    __extends(InvalidParameterValueException, _super);
    function InvalidParameterValueException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidParameterValueException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidParameterValueException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidParameterValueException.prototype);
        return _this;
    }
    return InvalidParameterValueException;
}(__BaseException));
export { InvalidParameterValueException };
var KMSAccessDeniedException = (function (_super) {
    __extends(KMSAccessDeniedException, _super);
    function KMSAccessDeniedException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSAccessDeniedException", $fault: "client" }, opts)) || this;
        _this.name = "KMSAccessDeniedException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSAccessDeniedException.prototype);
        return _this;
    }
    return KMSAccessDeniedException;
}(__BaseException));
export { KMSAccessDeniedException };
var KMSDisabledException = (function (_super) {
    __extends(KMSDisabledException, _super);
    function KMSDisabledException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSDisabledException", $fault: "client" }, opts)) || this;
        _this.name = "KMSDisabledException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSDisabledException.prototype);
        return _this;
    }
    return KMSDisabledException;
}(__BaseException));
export { KMSDisabledException };
var KMSInvalidStateException = (function (_super) {
    __extends(KMSInvalidStateException, _super);
    function KMSInvalidStateException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSInvalidStateException", $fault: "client" }, opts)) || this;
        _this.name = "KMSInvalidStateException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSInvalidStateException.prototype);
        return _this;
    }
    return KMSInvalidStateException;
}(__BaseException));
export { KMSInvalidStateException };
var KMSNotFoundException = (function (_super) {
    __extends(KMSNotFoundException, _super);
    function KMSNotFoundException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSNotFoundException", $fault: "client" }, opts)) || this;
        _this.name = "KMSNotFoundException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSNotFoundException.prototype);
        return _this;
    }
    return KMSNotFoundException;
}(__BaseException));
export { KMSNotFoundException };
var KMSOptInRequired = (function (_super) {
    __extends(KMSOptInRequired, _super);
    function KMSOptInRequired(opts) {
        var _this = _super.call(this, __assign({ name: "KMSOptInRequired", $fault: "client" }, opts)) || this;
        _this.name = "KMSOptInRequired";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSOptInRequired.prototype);
        return _this;
    }
    return KMSOptInRequired;
}(__BaseException));
export { KMSOptInRequired };
var KMSThrottlingException = (function (_super) {
    __extends(KMSThrottlingException, _super);
    function KMSThrottlingException(opts) {
        var _this = _super.call(this, __assign({ name: "KMSThrottlingException", $fault: "client" }, opts)) || this;
        _this.name = "KMSThrottlingException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, KMSThrottlingException.prototype);
        return _this;
    }
    return KMSThrottlingException;
}(__BaseException));
export { KMSThrottlingException };
var PlatformApplicationDisabledException = (function (_super) {
    __extends(PlatformApplicationDisabledException, _super);
    function PlatformApplicationDisabledException(opts) {
        var _this = _super.call(this, __assign({ name: "PlatformApplicationDisabledException", $fault: "client" }, opts)) || this;
        _this.name = "PlatformApplicationDisabledException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, PlatformApplicationDisabledException.prototype);
        return _this;
    }
    return PlatformApplicationDisabledException;
}(__BaseException));
export { PlatformApplicationDisabledException };
var BatchEntryIdsNotDistinctException = (function (_super) {
    __extends(BatchEntryIdsNotDistinctException, _super);
    function BatchEntryIdsNotDistinctException(opts) {
        var _this = _super.call(this, __assign({ name: "BatchEntryIdsNotDistinctException", $fault: "client" }, opts)) || this;
        _this.name = "BatchEntryIdsNotDistinctException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, BatchEntryIdsNotDistinctException.prototype);
        return _this;
    }
    return BatchEntryIdsNotDistinctException;
}(__BaseException));
export { BatchEntryIdsNotDistinctException };
var BatchRequestTooLongException = (function (_super) {
    __extends(BatchRequestTooLongException, _super);
    function BatchRequestTooLongException(opts) {
        var _this = _super.call(this, __assign({ name: "BatchRequestTooLongException", $fault: "client" }, opts)) || this;
        _this.name = "BatchRequestTooLongException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, BatchRequestTooLongException.prototype);
        return _this;
    }
    return BatchRequestTooLongException;
}(__BaseException));
export { BatchRequestTooLongException };
var EmptyBatchRequestException = (function (_super) {
    __extends(EmptyBatchRequestException, _super);
    function EmptyBatchRequestException(opts) {
        var _this = _super.call(this, __assign({ name: "EmptyBatchRequestException", $fault: "client" }, opts)) || this;
        _this.name = "EmptyBatchRequestException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, EmptyBatchRequestException.prototype);
        return _this;
    }
    return EmptyBatchRequestException;
}(__BaseException));
export { EmptyBatchRequestException };
var InvalidBatchEntryIdException = (function (_super) {
    __extends(InvalidBatchEntryIdException, _super);
    function InvalidBatchEntryIdException(opts) {
        var _this = _super.call(this, __assign({ name: "InvalidBatchEntryIdException", $fault: "client" }, opts)) || this;
        _this.name = "InvalidBatchEntryIdException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, InvalidBatchEntryIdException.prototype);
        return _this;
    }
    return InvalidBatchEntryIdException;
}(__BaseException));
export { InvalidBatchEntryIdException };
var TooManyEntriesInBatchRequestException = (function (_super) {
    __extends(TooManyEntriesInBatchRequestException, _super);
    function TooManyEntriesInBatchRequestException(opts) {
        var _this = _super.call(this, __assign({ name: "TooManyEntriesInBatchRequestException", $fault: "client" }, opts)) || this;
        _this.name = "TooManyEntriesInBatchRequestException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, TooManyEntriesInBatchRequestException.prototype);
        return _this;
    }
    return TooManyEntriesInBatchRequestException;
}(__BaseException));
export { TooManyEntriesInBatchRequestException };
var VerificationException = (function (_super) {
    __extends(VerificationException, _super);
    function VerificationException(opts) {
        var _this = _super.call(this, __assign({ name: "VerificationException", $fault: "client" }, opts)) || this;
        _this.name = "VerificationException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, VerificationException.prototype);
        _this.Message = opts.Message;
        _this.Status = opts.Status;
        return _this;
    }
    return VerificationException;
}(__BaseException));
export { VerificationException };
export var AddPermissionInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CheckIfPhoneNumberIsOptedOutInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CheckIfPhoneNumberIsOptedOutResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConfirmSubscriptionInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ConfirmSubscriptionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreatePlatformApplicationInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreatePlatformApplicationResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateEndpointResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreatePlatformEndpointInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateSMSSandboxPhoneNumberInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateSMSSandboxPhoneNumberResultFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateTopicInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateTopicResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteEndpointInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeletePlatformApplicationInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteSMSSandboxPhoneNumberInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteSMSSandboxPhoneNumberResultFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DeleteTopicInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetEndpointAttributesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetEndpointAttributesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPlatformApplicationAttributesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetPlatformApplicationAttributesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSMSAttributesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSMSAttributesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSMSSandboxAccountStatusInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSMSSandboxAccountStatusResultFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSubscriptionAttributesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetSubscriptionAttributesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTopicAttributesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var GetTopicAttributesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListEndpointsByPlatformApplicationInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var EndpointFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListEndpointsByPlatformApplicationResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListOriginationNumbersRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PhoneNumberInformationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListOriginationNumbersResultFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListPhoneNumbersOptedOutInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListPhoneNumbersOptedOutResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListPlatformApplicationsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PlatformApplicationFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListPlatformApplicationsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSMSSandboxPhoneNumbersInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SMSSandboxPhoneNumberFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSMSSandboxPhoneNumbersResultFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSubscriptionsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SubscriptionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSubscriptionsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSubscriptionsByTopicInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListSubscriptionsByTopicResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTagsForResourceRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTagsForResourceResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTopicsInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TopicFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ListTopicsResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var OptInPhoneNumberInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var OptInPhoneNumberResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MessageAttributeValueFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PublishInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PublishResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PublishBatchRequestEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PublishBatchInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var BatchResultErrorEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PublishBatchResultEntryFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PublishBatchResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RemovePermissionInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetEndpointAttributesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetPlatformApplicationAttributesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetSMSAttributesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetSMSAttributesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetSubscriptionAttributesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SetTopicAttributesInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SubscribeInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SubscribeResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagResourceRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagResourceResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UnsubscribeInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UntagResourceRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UntagResourceResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VerifySMSSandboxPhoneNumberInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var VerifySMSSandboxPhoneNumberResultFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
